export enum HsaClassificationReviewStatus {
  Auto = "auto",
  Confirmed = "confirmed",
  NeedsReview = "needs_review",
}
